{
  "codeList": [],
  "percentageList": [],
  "conditionList": [],
  "conditionVariantOptionList": [],
  "variantFamilyList": [],
  "variantOptionList": [],
  "productClassList": [],
  "marketList": [],
  "addedConditions": [],
  "showOnlyValidCodes": true, 
  "showOnlyValidConditions": true
}